// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img[data-v-654e9ac6]{position:relative;bottom:2px}`, "",{"version":3,"sources":["webpack://./Web/lk/create/CreateChallenge/Crown.vue"],"names":[],"mappings":"AACI,qBACI,iBAAA,CACA,UAAA","sourcesContent":["\n    img {\n        position: relative;\n        bottom: 2px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
